import { z } from 'zod';

export const NOTE_LIMITS = {
	title: 160,
	category: 80,
	note: 20000,
} as const;

export const NoteSchema = z.object({
	title: z
		.string()
		.trim()
		.min(1, 'Título é obrigatório')
		.max(NOTE_LIMITS.title, `Título deve ter no máximo ${NOTE_LIMITS.title} caracteres`),
	date: z.string().min(1, 'Data é obrigatória'),
	category: z
		.string()
		.trim()
		.max(NOTE_LIMITS.category, `Categoria deve ter no máximo ${NOTE_LIMITS.category} caracteres`)
		.optional()
		.default(''),
	note: z
		.string()
		.min(1, 'Conteúdo da nota é obrigatório')
		.max(NOTE_LIMITS.note, `Nota deve ter no máximo ${NOTE_LIMITS.note} caracteres`),
});

export type NoteSchemaType = z.infer<typeof NoteSchema>;
